import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    const update = () => {
      if (!anchor) {
        setVisible(window.scrollY > 500);
        return;
      }
      const bottom = anchor.getBoundingClientRect().bottom;
      setVisible(bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'}`} style={{
    paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
  }} data-id="element-123" data-mp="2atgy0fc8s03v">
      <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-xl animate-shake items-center justify-center gap-2 rounded-2xl bg-lime px-4 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-tight text-ink shadow-[0_18px_45px_-12px_rgba(0,0,0,0.9)] transition-colors duration-150 ease-out hover:bg-lime-bright focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-base" data-id="element-124" data-mp="2z4bppbw24fs8">
        Je veux ma Route Rénale — 19 €
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-125" data-mp="26dtmmavc2eet" />
      </a>
    </div>;
}